import {call} from "redux-saga/effects";
import * as HttpService from 'services/HttpService';
import {takeLatest, put} from 'redux-saga/effects';
import {
    getPlansList,
    plansSuccess,
    plansFailed,
    getPlan,
    planSuccess,
    planFailed,
    updatePlanStatus,
    planStatusUpdateSuccess,
    planStatusUpdateFailed,
    createNewPlan,
    updatePlan,
    planCreatedUpdated,
    planCreationFailed,
    deletePlan,
    planDeletedSuccessfully,
    planDeletionFailed,
    getPlansLookup,
    plansLookupSuccess,
    plansLookupFailed,
} from "../slices/plansSlice";
import { notification } from 'antd';

const endpoint = '/admin/plans';

function* fetchPlans(action) {
    try {
        const response = yield call(HttpService.get, endpoint, action.payload);
        const {plans} = response.data;
        if (plans) {
            yield put(plansSuccess(plans));
        }
    } catch (error) {
        yield put(plansFailed());
    }
}

function* fetchPlansLookup(action) {
    try {
        const response = yield call(HttpService.get, `${endpoint}/lookup`, action.payload);
        const {plans} = response.data;
        if (plans) {
            yield put(plansLookupSuccess(plans));
        }
    } catch (error) {
        yield put(plansLookupFailed());
    }
}

function* fetchPlan(action) {
    const {id} = action.payload;
    try {
        const response = yield call(HttpService.get, `${endpoint}/${id}`);
        const {plan} = response.data;
        if (plan) {
            yield put(planSuccess(plan));
        }
    } catch (error) {
        yield put(planFailed());
    }
}

function* createPlan(action) {
    try {
        const response = yield call(HttpService.post, `${endpoint}`, action.payload);
        if (response) {
            notification.success({message: 'Plan created', description: 'New Plan created successfully'});
            yield put(planCreatedUpdated());
        }
    } catch (error) {
        yield put(planCreationFailed());
    }
}

function* planUpdateRequest(action) {
    const {id, payload} = action.payload;
    try {
        const response = yield call(HttpService.post, `${endpoint}/${id}`, payload);
        if (response) {
            notification.success({message: 'Plan created', description: 'New Plan created successfully'});
            yield put(planCreatedUpdated());
        }
    } catch (error) {
        yield put(planCreationFailed());
    }
}

function* patchPlanStatus(action) {
    const {id, status, payment_status} = action.payload;
    try {
        const response = yield call(HttpService.patch, `${endpoint}/${id}`, {status, payment_status});
        if (response) {
            notification.success({message: 'Plan updated', description: 'Plan status updated successfully'});
            yield put(planStatusUpdateSuccess());
        }
    } catch (error) {
        yield put(planStatusUpdateFailed());
    }
}

function* deletePlanRequest(action) {
    const {id} = action.payload;
    try {
        const response = yield call(HttpService.del, `${endpoint}/${id}`);
        if (response) {
            notification.success({message: 'Plan deleted', description: 'Plan deleted successfully'});
            yield put(planDeletedSuccessfully({id}));
        }
    } catch (error) {
        yield put(planDeletionFailed());
    }
}

export default function* resourcesSaga() {
    yield takeLatest(getPlansList.type, fetchPlans);
    yield takeLatest(getPlansLookup.type, fetchPlansLookup);
    yield takeLatest(getPlan.type, fetchPlan);
    yield takeLatest(createNewPlan.type, createPlan);
    yield takeLatest(updatePlan.type, planUpdateRequest);
    yield takeLatest(deletePlan.type, deletePlanRequest);
    yield takeLatest(updatePlanStatus.type, patchPlanStatus);
}
